export default __webpack_public_path__ + "static/media/poolday.68c881b0.png";